import { useState } from "react";
import { View } from "react-native";
import { RecapScreenFragmentFragment } from "src/api/graphql/__generated__/graphql";
import GlowProgressBar from "src/components/GlowProgressBar";
import SlideView from "src/components/SlideView";
import { AnimatePresence } from "src/swsh-native";
import RecapScreenContent from "../../RecapScreenContent";
import { RECAP_ANIMATION_DURATION } from "../constants";

const RecapScreenContentContainer = ({
	curScreen,
	prevIndex,
	index,
	numTotalScreens,
	onSelect,
}: {
	curScreen: RecapScreenFragmentFragment | null | undefined;
	prevIndex: number | null;
	index: number;
	numTotalScreens: number;
	onSelect?: (index: number) => void;
}) => {
	const [containerDim, setContainerDim] = useState<null | { width: number; height: number }>(
		null,
	);

	return (
		<>
			<GlowProgressBar
				numTotal={numTotalScreens}
				numHighlighted={index + 1}
				width={(containerDim?.width ?? 0) - 50}
				onCompletePressed={onSelect}
				onIncompletePressed={onSelect}
				containerStyle={{
					opacity: containerDim ? 1 : 0,
				}}
			/>
			<View
				style={{
					flex: 1,
					overflow: "hidden",
					width: "100%",
				}}
				onLayout={(event) => {
					setContainerDim({
						width: event.nativeEvent.layout.width,
						height: event.nativeEvent.layout.height,
					});
				}}
			>
				{containerDim && (
					<AnimatePresence>
						<SlideView
							key={index}
							opacityEntering={index === 0 && prevIndex === null}
							direction={index >= (prevIndex ?? 0) ? "left" : "right"}
							// It's very difficult to get the directionality correct for exiting, so we just ignore the problem
							opacityExiting
							style={{
								position: "absolute",
								width: containerDim.width,
								height: containerDim.height,
							}}
							duration={RECAP_ANIMATION_DURATION}
						>
							{!!curScreen && (
								<RecapScreenContent
									screen={curScreen}
									contentAreaWidth={containerDim.width}
									contentAreaHeight={containerDim.height}
									onSelectionChange={(change) => {
										const newIndex = index + change;
										onSelect?.(newIndex);
									}}
								/>
							)}
						</SlideView>
					</AnimatePresence>
				)}
			</View>
		</>
	);
};
export default RecapScreenContentContainer;
